import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

scheduleReminderModalStyles.middleRowLeftColumnGridItem = { width: [12, 12, 12, 12, 12] };
scheduleReminderModalStyles.middleRowRightColumnGridItem = { width: [12, 12, 12, 12, 12] };

scheduleReminderModalStyles.startDateGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        flex-direction: column;
        align-items: initial;
    `,
};
scheduleReminderModalStyles.endDateGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        flex-direction: column;
        align-items: initial;
    `,
};

scheduleReminderModalStyles.modal = {
    cssOverrides: {
        modalTitle: css`
            align-items: flex-start;
            padding: 15px 30px;
        `,
        modalContent: css`
            padding: 20px 30px;
        `,
        modalBody: css`
            overflow-y: auto;
        `,
    },
};

scheduleReminderModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        font-family: "Roboto-Medium";
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};

scheduleReminderModalStyles.scheduleButton = {
    variant: "primary",
    css: css`
        font-family: "Roboto-Medium";
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};
